<template>
  <div>
    <v-card class="scan-record-list pa-5 elevation-3">
      <v-data-table
        :headers="headers"
        :items="scanRecordList"
        :items-per-page="10"
        multi-sort
      >
        <template #[`item.login_id`]="{ item }">
          <div
            style="cursor:pointer"
            :title="$t('general.detail', {item: null})"
            @click="detail(item)"
          >
            <v-icon
              class="mr-2"
              color="primary"
            >
              mdi-account-details
            </v-icon>
            {{ item.login_id }}
          </div>
        </template>
        <template #[`item.scan_type`]="{ item }">
          <v-chip
            v-if="item.scan_type"
            :color="getColor(item.scan_type)"
            dark
          >
            {{ formatScanType(item.scan_type) }}
          </v-chip>
        </template>
        <template #[`item.created_at`]="{ item }">
          {{ formatDate(item.created_at) }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<i18n src="./locales/en.json"></i18n>
<i18n src="./locales/zhHant.json"></i18n>

<script>
import ErrorDisplay from '@/components/functions/Common/mixins/ErrorDisplay'
import moment from 'moment'

export default {
  name: 'ScanRecordList',
  mixins: [ErrorDisplay],
  props: {
    scanRecordList: {
      type: Array,
      default: () => { return [] }
    }
  },
  data: function () {
    return {
      headers: [
        { text: this.$t('general.username'), value: 'login_id' },
        { text: this.$t('general.scanSn'), value: 'scan_sn' },
        { text: this.$t('general.scanType'), value: 'scan_type' },
        { text: this.$t('general.scanDate'), value: 'created_at' }
      ]
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    formatScanType (scanType) {
      if (scanType === 'product') return this.$t('general.product')
      if (scanType === 'certificate') return this.$t('general.certificate')
      return null
    },
    getColor (scanType) {
      if (scanType === 'product') return 'green'
      if (scanType === 'certificate') return 'blue'
      return null
    },
    formatDate (createdAt) {
      moment.locale(this.convertLocale(this.currentLocale, 'bcp47'))
      if (moment(createdAt).isValid()) return moment(createdAt).format('LLL')
      return null
    },
    detail (item) {
      this.$emit('detail', item)
    }
  }
}
</script>

<style scoped>
.scan-record-list {
  width: 100%
}
</style>
